import React, { useState, useLayoutEffect, useRef } from 'react';
import SEO from '../components/seo';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { gsap, TweenMax } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Layout from '../components/layout';
import SectionHeader from '../components/sectionHeader';
import ScrollReveal from '../components/scrollReveal';
import Parallax from '../components/parallax';
import Blinker from '../components/blinker';
import ScrollDown from '../components/scrollDown';
import Container from '../components/container';
import Footer from '../components/footer';
import { randomSelection } from '../utils';

const useStyles = makeStyles(theme => ({
  intro: {
    width: '100%',
    height: '90vh',
    marginTop: '10vh',
    padding: '0vh 0vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      // flexDirection: 'row',
      // alignItems: 'center',
      justifyContent: 'center',
    },
  },
  bannerA: {
    width: '100%',
    // minHeight: '30vh',
    height: '30vh',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      height: '50vh',
    },
  },
  projectSection: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    [theme.breakpoints.up('sm')]: {},
  },
  bannerB: {
    width: '100%',
    height: '20vh',
    overflow: 'hidden',
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      height: '50vh',
    },
  },
  stuff: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    [theme.breakpoints.up('sm')]: {},
  },
  testimony: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    borderTop: '2px solid #000000',
    [theme.breakpoints.up('sm')]: {},
  },
  about: {
    // marginTop: theme.spacing(10),
    position: 'relative',
    overflow: 'hidden',
  },
  technologies: {
    // marginTop: theme.spacing(10),
    position: 'relative',
    overflow: 'hidden',
  },
  contact: {
    height: '80vh',
    marginTop: theme.spacing(10),
    position: 'relative',
    backgroundColor: 'rgb(255, 88, 21)',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      height: 'auto',
    },
  },
  bullet: {
    position: 'absolute',
    '&:before': {
      content: '',
      width: '9px',
      height: '9px',
      position: 'absolute',
      top: '0px',
      transform: 'translate3d(-50%, -100%, 0)',
      borderRadius: '50%',
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  introText: {
    maxWidth: '90%',
    marginTop: '80px',
    marginLeft: '5%',
    // marginLeft: theme.spacing(5),
    position: 'static',
    // left: 'calc(-15vw + 20px)',
    // bottom: theme.spacing(3),
    zIndex: '500',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '90vw',
      marginTop: '-100px',
      marginLeft: '5%',
    },
  },
  scrollDown: {
    width: '3vw',
    position: 'absolute',
    left: theme.spacing(5),
    bottom: theme.spacing(3),
    zIndex: '10000',
    [theme.breakpoints.up('sm')]: {
      width: '1vw',
      position: 'absolute',
      left: '50%',
      bottom: theme.spacing(10),
      transform: 'translate(40%, 0)',
    },
  },
  digiBlock: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '60%',
      alignSelf: 'flex-start',
      // marginLeft: theme.spacing(5),
    },
  },
  boldHeader: {
    fontWeight: '700',
    marginBottom: '20px',
    [theme.breakpoints.down('xs')]: {
      marginButtom: '40px',
      fontSize: theme.typography.h3.fontSize,
    },
  },
  projectItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  bannerImage: {
    // width: '100vw',
    height: '60vh',
    borderRadius: '6px',
    opacity: '1',
    // position: 'absolute',
    // top: '0',
    // left: '0',
    filter: 'grayscale(1)',
    [theme.breakpoints.up('sm')]: {
      marginTop: '-40vh',
      height: '200vh',
    },
  },
  bannerImageLaptop: {
    width: '100%',
    borderRadius: '6px',
    opacity: '1',
    filter: 'grayscale(1)',
    [theme.breakpoints.up('sm')]: {
      marginTop: '-5vh',
    },
  },
  aboutImageContainer: {
    width: '100%',
    height: '300px',
    maxHeight: '300px',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {},
  },
  aboutImage: {
    // width: '100%',
    height: '360px',
    [theme.breakpoints.up('sm')]: {},
  },
  lagosCaption: {
    [theme.breakpoints.up('sm')]: {
      marginTop: '-80px',
    },
  },
  techImage: {
    width: '100%',
    height: '330px',
    maxHeight: '330px',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      height: '420px',
      maxHeight: '420px',
    },
    '&>img': {
      width: '100%',
      verticalAlign: 'center',
    },
  },
  skillsDeck: {
    minHeight: '60vh',
    marginTop: theme.spacing(5),
    color: '#f8f8f8',
    backgroundColor: '#000000',
    borderRadius: '6px',
    [theme.breakpoints.up('sm')]: {
      minHeight: '60vh',
      padding: '80px 90px',
    },
  },
  fadeSkills: {
    opacity: '0.5',
  },
  reachMe: {
    backgroundColor: '#222222',
    position: 'fixed',
    bottom: theme.spacing(10),
    right: theme.spacing(10),
  },
  projectsColumn: {
    height: '70vh',
    display: 'flex',
    justifyContent: 'center',
    overflow: 'scroll',
  },
  containerHost: {
    width: '70%',
    height: 'auto',
  },
  projectDetails: {
    width: '100vw',
    height: 'auto',
    minHeight: '100vh',
    padding: '40px',
    backgroundColor: theme.palette.background.default,
    position: 'fixed',
    top: '0',
    right: '-100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
    zIndex: '5000',
    [theme.breakpoints.up('sm')]: {},
  },
  activeProjectTitle: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'absolute',
    top: theme.spacing(30),
    right: '20px',
    [theme.breakpoints.up('sm')]: {
      right: '90px',
    },
  },
  projButtonsContainer: {
    position: 'absolute',
    top: theme.spacing(20),
    right: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      right: '90px',
    },
  },
  projectCloseButton: {
    [theme.breakpoints.up('sm')]: {},
  },
  projNavContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    zInedx: '10000',
    [theme.breakpoints.up('sm')]: {},
  },
  projPrevNextButton: {
    fontSize: theme.typography.h6.fontSize,
  },
  activeProjectDescription: {
    position: 'absolute',
    top: theme.spacing(40),
    right: '20px',
    [theme.breakpoints.up('sm')]: {
      right: '90px',
    },
  },
  contactMe: {
    width: '30vw',
    marginBottom: '20vh',
  },
  imgContainer: {
    // borderRadius: '12px',
    width: '100%',
    backgroundColor: '#ffffff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&>img': {
      width: '100%',
      borderRadius: '3px',
    },
  },
  bannerContainer: {
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      height: '100vh',
    },
  },
  smart: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    background: 'rgba(0, 0, 0, 0.1)',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  introDrop: {
    width: '130px',
    height: '130px',
    backgroundColor: '#1c1c1c',
    borderRadius: '50%',
    margin: '120px 0 0 20px',
    position: 'absolute',
    right: '12px',
    bottom: '60px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      width: '209px',
      height: '209px',
      margin: '120px 0 0 180px',
    },
  },
  drop: {
    width: '130px',
    height: '130px',
    backgroundColor: '#1c1c1c',
    borderRadius: '50%',
    margin: '120px 0 0 20px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      width: '209px',
      height: '209px',
      margin: '120px 0 0 180px',
    },
  },
  call: {
    width: '180px',
    height: '180px',
    backgroundColor: '#ffffff',
    borderRadius: '50%',
    margin: '40px 0 0 40px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      width: '250px',
      height: '250px',
      margin: '40px 0 0 100px',
    },
  },
  dropImg: {
    transform: 'rotate(-30deg)',
  },
  dropText: {
    color: '#f2f2f2',
    transform: 'rotate(-12deg)',
  },
  callText: {
    color: '#1c1c1c',
    transform: 'rotate(12deg)',
  },
  projectsSubtitle: {
    // marginBottom: theme.spacing(5),
    // fontFamily: 'Typ-Bold',
    // fontSize: '24px',
    // lineHeight: '1.6',
    '&>span': {
      display: 'block',
    },
  },
  button: {
    padding: '20px 20px',
    marginTop: '20px',
    fontSize: '12x',
    [theme.breakpoints.up('sm')]: {
      padding: '22px 40px',
      marginTop: '40px',
    },
    '&:hover': {
      // padding: '10px',
    },
  },
  buttonLink: {
    width: '100%',
    maxWidth: '100%',
    color: '#ffffff',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%',
    },
    '&:hover': {
      color: '#ffffff',
    },
  },
  body1Margin: {
    margin: '0 0 20px 0',
    [theme.breakpoints.up('sm')]: {
      margin: '0 0 40px 0',
    },
  },
  captionText: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(3),
    },
  },
  mikeACaption: {
    marginBottom: theme.spacing(5),
  },
  shake: {
    width: '100%',
    position: 'absolute',
    overflow: 'hidden',
    zIndex: '-1',
    bottom: '40px',
    [theme.breakpoints.up('sm')]: {
      top: '50%',
      bottom: 'auto',
      transform: 'translate(0, -50%)',
    },
    '&>svg': {
      width: '100%',
    },
    '&>div': {
      width: '50px',
      height: '50px',
      zIndex: '-1',
      backgroundColor: 'rgb(255, 88, 21)',
      borderRadius: '50%',
      position: 'absolute',
      bottom: '50px',
      right: '50px',
      [theme.breakpoints.up('sm')]: {
        width: '100px',
        height: '100px',
        bottom: '100px',
        right: '100px',
      },
    },
  },
  shakeFill: {
    fill: 'rgb(65,  74, 107)',
    opacity: '0',
  },
  shakeStroke: {
    fill: 'none',
    stroke: '#000000',
    // strokeMiterlimit: "10",
    strokeWidth: '40px',
    strokeDasharray: '12000',
    strokeDashoffset: '1200',
    [theme.breakpoints.up('sm')]: {
      strokeDashoffset: '2500',
    },
  },
  divider: {
    width: '100%',
    height: '0px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    backgroundColor: 'rgb(255, 88, 21)',
    display: 'none',
  },
  projects: {
    marginTop: '10px',
    padding: '20px',
    backgroundColor: '#fffefe',
    [theme.breakpoints.up('sm')]: {
      marginTop: '40px',
      padding: '40px',
    },
  },
  projectImage: {
    width: '100%',
    height: '200px',
    marginBottom: '20px',
    overflow: 'hidden',
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '0',
    },
    '&>img': {
      width: '100%',
      filter: 'grayscale(1)',
      '&:hover': {
        filter: 'none',
      },
    },
  },
  langCaption: {
    marginRight: '24px',
    padding: '6px',
    color: '#aaaaaa',
    border: '1px solid #aaaaaa',
  },
  pointerContainer: {
    width: '50vw',
    position: 'absolute',
    top: '80vh',
    left: '50%',
    transform: 'translate(-50%, 0)',
    [theme.breakpoints.up('sm')]: {
      top: '60vh',
    },
    '&>svg': {
      width: '100%',
      fill: 'rgba(65, 74, 107)',
      display: 'none',
    },
  },
  mockUpContainer: {
    position: 'absolute',
    top: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&>img': {
      width: '70%',
    },
  },
  principlesWheel: {
    width: '100%',
    marginTop: '10vh',
    marginBottom: '10vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      width: '30%',
      margin: 'auto',
      justifyContent: 'center',
    },
    '&>img': {
      width: '100%',
    },
    '&:after': {
      content: '""',
      width: '25px',
      height: '25px',
      backgroundColor: 'rgb(255, 88, 21)',
      borderRadius: '50%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      [theme.breakpoints.up('sm')]: {
        width: '100px',
        height: '100px',
      },
    },
  },
  services: {
    '&>div': {
      marginBotton: '20px',
      [theme.breakpoints.up('sm')]: {
        marginBottom: '40px',
      },
    },
  },
  worldMap: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    filter: 'graysclae(1)',
    '&>img': {
      maxWidth: '100%',
    },
  },
  rating: {
    '&>img': {
      width: '24px',
    },
  },
}));

//colors for masking projects
const colors = [
  // '#ec654d',
  '#1c1c1c',
  // '#e99400',
  // '#14c96b',
  // '#299e85',
  // '#28bfe2',
];

const projectsList = [
  {
    id: '1',
    title: 'Carbon Card',
    mockUp: require('../assets/images/carbon_card.jpg'),
  },
  {
    id: '2',
    title: 'Woody Consult',
    mockUp: require('../assets/images/woody_consult.jpg'),
  },
  {
    id: '3',
    title: 'Minixels',
    mockUp: require('../assets/images/minixels.jpg'),
  },
];

const Homepage = props => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const [activeProject, setActiveProject] = useState(projectsList[0]);
  const [activeProjectVisibility, setActiveProjectVisibility] = useState(false);
  const shakeFill = useRef(null);
  const shakeStroke = useRef(null);
  const projectDetails = useRef(null);
  const name = useRef(null);
  const descriptionOfMike = useRef(null);
  const arrow1 = useRef(null);
  const arrow2 = useRef(null);
  const principlesWheel = useRef(null);
  const footerHand = useRef(null);

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    //intro animation
    const introAnim = gsap.timeline({ delay: 5 });
    !isMobile
      ? introAnim
          .from(name.current, {
            y: '100%',
            opacity: 0,
            ease: 'power4',
            duration: 1,
          })
          .from(descriptionOfMike.current, {
            y: '0',
            opacity: 0,
            ease: 'power4',
            duration: 1,
          })
      : mob();

    //shake animation
    const shakeAnim = gsap.timeline({
      delay: 2,
      // yoyo: true,
      repeat: '-1',
      scrollTrigger: {
        trigger: '#intro',
      },
    });
    isMobile
      ? shakeAnim
          .to(shakeStroke.current, {
            strokeDashoffset: '0',
            duration: 4,
            ease: 'power4',
          })
          .to(shakeFill.current, { opacity: '0', duration: 2 })
      : shakeAnim.to(shakeFill.current, { opacity: '0', duration: 2 });

    //principles-wheel anim
    !isMobile
      ? gsap.to(principlesWheel.current, {
          transform: !isMobile ? 'scale(1.2)' : 'scale(1)',
          duration: '0.8',
          yoyo: true,
          repeat: -1,
          scrollTrigger: principlesWheel.current,
        })
      : mob();
  }, [isMobile]);

  //event handlers
  function mob() {
    const m = isMobile;
  }

  function showProject(project) {
    setActiveProject(project);
    setActiveProjectVisibility(true);
  }

  function hideProjectVisibility() {
    setActiveProjectVisibility(false);
  }

  function prevProject(projectsList) {
    const currentIndex = projectsList.indexOf(activeProject);
    const prevIndex =
      currentIndex > 0 ? currentIndex - 1 : projectsList.length - 1;
    setActiveProject(projectsList[prevIndex]);
  }

  function nextProject(projectsList) {
    const currentIndex = projectsList.indexOf(activeProject);
    const nextIndex =
      currentIndex < projectsList.length
        ? currentIndex + 1 !== projectsList.length
          ? currentIndex + 1
          : 0
        : 0;
    setActiveProject(projectsList[nextIndex]);
  }

  //tweens
  TweenMax.to(projectDetails.current, 0.8, {
    x: activeProjectVisibility ? '-100%' : '0',
  });

  const siteTitle = 'Mike Abolarin';
  return (
    <Layout>
      <SEO title={siteTitle} />

      <main style={{ padding: !isMobile ? '40px' : '0' }}>
        <section id="intro" className={classes.intro}>
          <div className={classes.introText}>
            <div style={{ overflow: 'hidden' }}>
              <div ref={name}>
                {/* <Typography variant="h6">{'{}'}</Typography> */}
                <Typography variant="h1" className={classes.boldHeader}>
                  Mike Abolarin
                </Typography>
              </div>
            </div>
            <div style={{ overflow: 'hidden' }} className={classes.digiBlock}>
              <div ref={descriptionOfMike}>
                <Typography variant="subtitle1">
                  <span>Digital Product </span>
                  <span>Designer and </span>
                  <span>Javascript Developer based </span>
                  <span>in Badagry, Lagos. </span>
                  <span>Working with brands to create </span>
                  <span>awesome</span> products
                  <br />
                  <span role="img" aria-label="emoji expressions">
                    {/* 🤣 */}
                  </span>
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onMouseEnter={() => {
                    gsap.to(arrow1.current, {
                      css: {
                        marginLeft: '40px',
                      },
                      duration: 0.8,
                      ease: 'power4',
                    });
                  }}
                  onMouseLeave={() => {
                    gsap.to(arrow1.current, {
                      css: {
                        marginLeft: '17px',
                      },
                      duration: 0.8,
                      ease: 'power4',
                    });
                  }}
                >
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=michaelwest505@gmail.com&su=JOB PROPOSAL&body=BODY"
                    className={classes.buttonLink}
                    target="__blank"
                  >
                    Drop an Email
                    <svg
                      ref={arrow1}
                      viewBox="0 0 15.41 9.41"
                      width="17px"
                      fill="#ffffff"
                      style={{ marginLeft: '12px' }}
                    >
                      <path d="M10.71 0a2 2 0 000 2.83.52.52 0 01-.37.88H0v2h10.34a.52.52 0 01.37.88 2 2 0 000 2.82l4.7-4.7z" />
                    </svg>
                  </a>
                </Button>
              </div>
            </div>
          </div>
          <div className={classes.shake}>
            <svg viewBox="0 0 4700.28 1462.2">
              <path
                ref={shakeFill}
                d="M3524,712.86V739a38.2,38.2,0,0,0,38.2,38.2h821.6a38.2,38.2,0,0,1,38.2,38.2v25.1a38.2,38.2,0,0,1-38.2,38.2H3826.2a38.2,38.2,0,0,0-38.2,38.2V943a38.2,38.2,0,0,0,38.2,38.2h609.94a38.2,38.2,0,0,1,38.2,38.2v25.1a38.2,38.2,0,0,1-38.2,38.2H3994.2a38.2,38.2,0,0,0-38.2,38.2V1147a38.2,38.2,0,0,0,38.2,38.2H4509a89.08,89.08,0,0,0,87.62-73.05L4697.71,559.2a157.44,157.44,0,0,0-65.39-157.85L4344.84,202.77a38.2,38.2,0,0,0-52,8.12l-21,27.32a38.18,38.18,0,0,0,7.65,54.08l148.93,109.42a38.2,38.2,0,0,1-22.59,69l-579.66.44a38.2,38.2,0,0,0-38.17,38.2V535a38.2,38.2,0,0,0,38.2,38.2h450.6a38.2,38.2,0,0,1,38.2,38.2v25.1a38.2,38.2,0,0,1-38.2,38.2H3562.2A38.2,38.2,0,0,0,3524,712.86Z"
                className={classes.shakeFill}
              />
              <path
                ref={shakeStroke}
                d="M4587,283.16,4215.84,26.77a38.2,38.2,0,0,0-52,8.12l-21,27.31a38.19,38.19,0,0,0,7.65,54.09l148.93,109.42A38.22,38.22,0,0,1,4315,256.49h0a38.2,38.2,0,0,1-38.17,38.2l-579.66.44A38.19,38.19,0,0,0,3659,333.32V359a38.2,38.2,0,0,0,38.2,38.2h450.6a38.19,38.19,0,0,1,38.2,38.19v25.11a38.2,38.2,0,0,1-38.2,38.2H3433.2a38.19,38.19,0,0,0-38.2,38.19V563a38.2,38.2,0,0,0,38.2,38.2h821.6a38.19,38.19,0,0,1,38.2,38.19v25.11a38.2,38.2,0,0,1-38.2,38.2H3697.2a38.19,38.19,0,0,0-38.2,38.19V767a38.2,38.2,0,0,0,38.2,38.2h609.94a38.19,38.19,0,0,1,38.2,38.19v25.11a38.2,38.2,0,0,1-38.2,38.2H3865.2a38.19,38.19,0,0,0-38.2,38.19V971a38.2,38.2,0,0,0,38.2,38.2h587.6a38.19,38.19,0,0,1,38.2,38.19V1092a38.2,38.2,0,0,1-38.2,38.2H3433.2a38.19,38.19,0,0,0-38.2,38.19V1198a38.19,38.19,0,0,0,20.5,33.85l208.44,109a38.2,38.2,0,0,1,15.51,52.72l-16.67,29.33a38.19,38.19,0,0,1-50.07,15.39L2613,966.08a38.17,38.17,0,0,0-16.86-3.92H0"
                className={classes.shakeStroke}
              />
            </svg>
            <div />
          </div>
          <div className={classes.scrollDown}>
            <ScrollDown />
          </div>
        </section>
        <section id="banner-0" className={classes.bannerA}>
          <div className={classes.bannerContainer}>
            <Parallax y={['0', '20%']}>
              <img
                src={require('../assets/images/programmer.jpg')}
                className={classes.bannerImage}
                alt=""
              />
            </Parallax>
          </div>
        </section>
        <section id="projects" className={classes.projectSection}>
          <Container>
            <ScrollReveal direction="up">
              <SectionHeader
                line1="Pro"
                line2="jects."
                color="rgb(255, 88, 21)"
                isMobile
              />
            </ScrollReveal>
            <ScrollReveal direction="up">
              <Grid container>
                <Grid item xs={12} sm={6} container>
                  <Grid tem xs={12} sm={6}>
                    <Typography variant="subtitle1">
                      <div>
                        Curated set of projects from varied clients
                        <span>.</span>
                      </div>
                    </Typography>
                    <Typography variant="body1" className={classes.body1Margin}>
                      <span>I help brands and </span>
                      <span>smart businesses </span>
                      <span>deliver user- </span>
                      <span>
                        centered products
                        <span>.</span>{' '}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </ScrollReveal>
            {!isMobile && (
              <>
                <div className={classes.divider} />
                <ScrollReveal direction="right">
                  <Paper elevation={2}>
                    <Grid container className={classes.projects}>
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        className={classes.projectImage}
                        onClick={() => {
                          showProject(projectsList[0]);
                        }}
                      >
                        <img
                          src={require('../assets/images/carbon_card_preview.jpg')}
                          alt="carbon card"
                        />
                      </Grid>
                      <Grid item xs={12} sm={8}>
                        <Container noTopBottom disable={isMobile}>
                          <Typography variant="h6" gutterBottom>
                            Carbon Credit Card
                          </Typography>
                          <Typography variant="body1" paragraph>
                            My goal for this website was to showcase the
                            company's about to be launched product in a visually
                            explanatory way. I worked with a copywriter on this
                            project who was able to work within the concept
                            established. The client gave us a <strong>5</strong>{' '}
                            star rating expressing his pleasure.
                          </Typography>
                          <Typography variant="caption">
                            <span className={classes.langCaption}>Reactjs</span>
                            <span className={classes.langCaption}>Gatsby</span>
                            <span className={classes.langCaption}>Mui</span>
                          </Typography>
                        </Container>
                      </Grid>
                    </Grid>
                  </Paper>
                </ScrollReveal>
                <div className={classes.divider} />
                <ScrollReveal direction="right">
                  <Paper elevation={2}>
                    <Grid container className={classes.projects}>
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        className={classes.projectImage}
                        onClick={() => {
                          showProject(projectsList[1]);
                        }}
                      >
                        <img
                          src={require('../assets/images/woody_consult_preview.jpg')}
                          alt="carbon card"
                        />
                      </Grid>
                      <Grid item xs={12} sm={8}>
                        <Container noTopBottom>
                          <Typography variant="h6" gutterBottom>
                            Woody Consult
                          </Typography>
                          <Typography variant="body1" paragraph>
                            As part of the organization's commitment to
                            fostering tech culture in the country, this website
                            was concieved as a veritable channel for publicing
                            their cyber camp program. My approach was to employ
                            a clear and coherent layout, unambigious typography
                            and story-packed imagery.
                          </Typography>
                          <Typography variant="caption">
                            <span className={classes.langCaption}>Reactjs</span>
                            <span className={classes.langCaption}>Gatsby</span>
                            <span className={classes.langCaption}>Mui</span>
                          </Typography>
                        </Container>
                      </Grid>
                    </Grid>
                  </Paper>
                </ScrollReveal>
                <div className={classes.divider} />
                <ScrollReveal direction="right">
                  <Paper elevation={2}>
                    <Grid
                      container
                      className={classes.projects}
                      onClick={() => {
                        showProject(projectsList[2]);
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        className={classes.projectImage}
                      >
                        <img
                          src={require('../assets/images/minixels_preview.jpg')}
                          alt="carbon card"
                        />
                      </Grid>
                      <Grid item xs={12} sm={8}>
                        <Container noTopBottom>
                          <Typography variant="h6" gutterBottom>
                            Minixels
                          </Typography>
                          <Typography variant="body1" paragraph>
                            The idea here was to investigate how a minimalist
                            aesthetic could work perfectly in a gallery of
                            sorts. Minimalism suggests a preference for neutral
                            hues, simple typography and uncluttered layout. The
                            project was basically a test of my ability in doing
                            really simple things.
                          </Typography>
                          <Typography variant="caption">
                            <span className={classes.langCaption}>Reactjs</span>
                            <span className={classes.langCaption}>Gatsby</span>
                            <span className={classes.langCaption}>Mui</span>
                          </Typography>
                        </Container>
                      </Grid>
                    </Grid>
                  </Paper>
                </ScrollReveal>
                <div className={classes.divider} />
              </>
            )}
            {isMobile && (
              <ScrollReveal direction="right">
                <div className={classes.divider} />
                <Paper elevation={2}>
                  <Grid container className={classes.projects}>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      className={classes.projectImage}
                      onClick={() => {
                        showProject(projectsList[0]);
                      }}
                    >
                      <img
                        src={require('../assets/images/carbon_card_preview.jpg')}
                        alt="carbon card"
                      />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="h6" gutterBottom>
                        Carbon Credit Card
                      </Typography>
                      <Typography variant="body1" paragraph>
                        My goal for this website was to showcase the company's
                        about to be launched product in a visually explanatory
                        way. I worked with a copywriter on this project who was
                        able to work within the concept established. The client
                        gave us a five star rating expressing his pleasure.
                      </Typography>
                      <Typography variant="caption">
                        <span className={classes.langCaption}>Reactjs</span>
                        <span className={classes.langCaption}>Gatsby</span>
                        <span className={classes.langCaption}>Mui</span>
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
                <div className={classes.divider} />
                <Paper elevation={2}>
                  <Grid container className={classes.projects}>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      className={classes.projectImage}
                      onClick={() => {
                        showProject(projectsList[1]);
                      }}
                    >
                      <img
                        src={require('../assets/images/woody_consult_preview.jpg')}
                        alt="carbon card"
                      />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="h6" gutterBottom>
                        Woody Consult
                      </Typography>
                      <Typography variant="body1" paragraph>
                        As part of the organization's commitment to fostering
                        tech culture in the country, this website was concieved
                        as a veritable channel for publicing their cyber camp
                        program. My approach was to employ a clear and coherent
                        layout, unambigious typography and story-packed imagery.
                      </Typography>
                      <Typography variant="caption">
                        <span className={classes.langCaption}>Reactjs</span>
                        <span className={classes.langCaption}>Gatsby</span>
                        <span className={classes.langCaption}>Mui</span>
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
                <div className={classes.divider} />
                <Paper elevation={2}>
                  <Grid
                    container
                    className={classes.projects}
                    onClick={() => {
                      showProject(projectsList[2]);
                    }}
                  >
                    <Grid item xs={12} sm={4} className={classes.projectImage}>
                      <img
                        src={require('../assets/images/minixels_preview.jpg')}
                        alt="carbon card"
                      />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="h6" gutterBottom>
                        Minixels
                      </Typography>
                      <Typography variant="body1" paragraph>
                        The idea here was to investigate how a minimalist
                        aesthetic could work perfectly in a gallery of sorts.
                        Minimalism suggests a preference for neutral hues,
                        simple typography and uncluttered layout. The project
                        was basically a test of my ability in doing really
                        simple things.
                      </Typography>
                      <Typography variant="caption">
                        <span className={classes.langCaption}>Reactjs</span>
                        <span className={classes.langCaption}>Gatsby</span>
                        <span className={classes.langCaption}>Mui</span>
                      </Typography>
                    </Grid>
                    <div className={classes.divider} />
                  </Grid>
                </Paper>
              </ScrollReveal>
            )}
          </Container>
        </section>
        <section id="about" className={classes.about}>
          <Container>
            <ScrollReveal direction="up">
              <SectionHeader
                line1="Ab"
                line2="out."
                color="rgb(65, 74, 107)"
                isMobile
              />
            </ScrollReveal>
            <Grid container>
              <Grid item xs={12} sm={6}></Grid>
              <Grid item xs={12} sm={6}>
                <ScrollReveal direction="up">
                  <Typography variant="h6" gutterBottom>
                    <strong>
                      <div>Coding since </div>
                      <div>2014 </div>
                      <div>
                        In Lagos, Nigeria
                        <span>.</span>
                      </div>
                    </strong>
                  </Typography>
                </ScrollReveal>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={6}>
                {!isMobile && (
                  <Container noTopBottomLeft>
                    <div className={classes.aboutImageContainer}>
                      <Parallax y={['0', '20%']}>
                        <img
                          src={require('../assets/images/self-portrait.jpg')}
                          alt="selfportrait"
                          className={classes.aboutImage}
                        />
                      </Parallax>
                    </div>
                  </Container>
                )}
              </Grid>
              <Grid container item xs={12} sm={6}>
                <Grid item xs={12} sm={6}>
                  <ScrollReveal direction="up">
                    <Typography
                      variant="body1"
                      className={classes.text}
                      paragraph
                    >
                      My life revolves around computers. I'm interested in the
                      capacity of thoughtful experience design and
                      implementation in giving life to ideas. I think great
                      aesthetics imbue ideas with a viscereal look and feel,
                      thus keeping users of a product interested.
                    </Typography>
                    <Typography
                      variant="body1"
                      className={classes.text}
                      paragraph
                    >
                      I love listening to podcasts, learning about cultural
                      trends, and feasting on visual designs in my spare time.
                    </Typography>
                  </ScrollReveal>
                </Grid>
              </Grid>
            </Grid>
          </Container>
          <Grid container>
            <Grid item xs={12} sm={5}>
              {isMobile && (
                <ScrollReveal direction="right">
                  <div className={classes.aboutImageContainer}>
                    <img
                      className={classes.aboutImage}
                      src={require('../assets/images/self-portrait.jpg')}
                      alt="self-portrait"
                    />
                  </div>
                  <Typography
                    variant="caption"
                    component="div"
                    align="right"
                    className={classes.mikeACaption}
                  >
                    <strong>Mike Abolarin</strong>
                  </Typography>
                </ScrollReveal>
              )}
            </Grid>
          </Grid>
        </section>
        {!isMobile && (
          <section id="banner-b" className={classes.bannerB}>
            <div className={classes.bannerContainer}>
              <Parallax y={['0', '20%']}>
                <div className={classes.worldMap}>
                  <img src={require('../assets/images/world-map.png')} alt="" />
                </div>
              </Parallax>
            </div>
          </section>
        )}
        <section id="technologies" className={classes.technologies}>
          <Container noBottom>
            <ScrollReveal direction="up">
              <SectionHeader line1="Tech" line2="." color="#000000" isMobile />
            </ScrollReveal>
          </Container>
          <Container>
            <Grid container>
              <Grid item xs={12} sm={4}>
                <Grid container>
                  <Grid item xs={12} sm={9}>
                    <ScrollReveal direction="up">
                      <Typography variant="h6" paragraph>
                        <div>
                          <strong>Languages </strong>
                        </div>
                        <div>
                          <strong> & tools</strong>
                        </div>
                        <div>
                          <strong>
                            {' '}
                            I'm using <span>.</span>
                          </strong>
                        </div>
                      </Typography>
                    </ScrollReveal>
                    <ScrollReveal direction="up">
                      <Typography
                        variant="body1"
                        className={classes.text}
                        paragraph
                      >
                        Most Recently, I have been working in the React
                        ecosystem with all the usual suspects i.e Webpack,
                        Babel, Redux, Gatsby, etc. I'm a big fan CSS although
                        increasingly adopting JSS as a nod to the component
                        paradigm. My time is spent between PDFs advancing my
                        skills, codepens and blog articles.
                      </Typography>
                    </ScrollReveal>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={8}>
                {!isMobile && (
                  <ScrollReveal direction="left">
                    <div className={classes.skillsDeck}>
                      <Container>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography variant="h4" gutterBottom>
                              Design
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className={classes.fadeSkills}
                            >
                              <div>Adobe photoshop</div>
                              <div>Adobe illustrator</div>
                              <div>Autodesk 3Ds Max</div>
                              <div>Adobe XD</div>
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="h4" gutterBottom>
                              Development
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              className={classes.fadeSkills}
                            >
                              <div>HTML</div>
                              <div>CSS</div>
                              <div>Javascript</div>
                              <div>Python</div>
                              <div>Java</div>
                              <div>Git, GitHub</div>
                              <div>React</div>
                              <div>Gatsby</div>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Container>
                    </div>
                  </ScrollReveal>
                )}
              </Grid>
            </Grid>
          </Container>
          {isMobile && (
            <ScrollReveal direction="left">
              <div className={classes.skillsDeck}>
                <Container>
                  <Grid container>
                    <Grid item xs={6}>
                      <Typography variant="h6" gutterBottom>
                        Design
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.fadeSkills}
                      >
                        <div>Adobe photoshop</div>
                        <div>Adobe illustrator</div>
                        <div>Autodesk 3Ds Max</div>
                        <div>Adobe XD</div>
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="h6" gutterBottom>
                        Development
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.fadeSkills}
                      >
                        <div>HTML</div>
                        <div>CSS</div>
                        <div>Javascript</div>
                        <div>Python</div>
                        <div>Java</div>
                        <div>Git, GitHub</div>
                        <div>React</div>
                        <div>Gatsby</div>
                      </Typography>
                    </Grid>
                  </Grid>
                </Container>
              </div>
            </ScrollReveal>
          )}
          <div className={classes.stuff}>
            <Container>
              <Grid container>
                <Grid xs={12} sm={4}>
                  <Typography
                    variant="caption"
                    component="p"
                    style={{ marginBottom: '15px' }}
                  >
                    STUFF I CAN DO
                  </Typography>
                  <Typography
                    variant={!isMobile ? 'h4' : 'h5'}
                    className={classes.services}
                  >
                    <div>Web Design.</div>
                    <div>Javascript-Development.</div>
                    <div>Branding.</div>
                    <div>Graphics Design.</div>
                  </Typography>
                </Grid>
                <Grid xs={12} sm={8}>
                  <div
                    ref={principlesWheel}
                    className={classes.principlesWheel}
                  >
                    <img
                      src={require('../assets/images/principles-wheel.svg')}
                      alt="principles-wheel"
                    />
                  </div>
                </Grid>
              </Grid>
            </Container>
          </div>
        </section>
        <section id="contact" className={classes.contact}>
          <Container center column>
            <ScrollReveal direction="up">
              <Typography
                variant="body1"
                justify="center"
                align="center"
                className={classes.captionText}
              >
                <div style={{ color: '#000000' }}>
                  Collaborating with ambitious brands and people.
                </div>
              </Typography>
              <Typography
                variant={!isMobile ? 'h1' : 'h5'}
                justify="center"
                align="center"
              >
                <div>Let's work together.</div>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onMouseEnter={() => {
                    gsap.to(arrow2.current, {
                      css: {
                        marginLeft: '40px',
                      },
                      duration: 0.8,
                      ease: 'power4',
                    });
                    gsap.to(footerHand.current, {
                      y: '-=400px',
                      duration: 0.8,
                      ease: 'power4',
                    });
                  }}
                  onMouseLeave={() => {
                    gsap.to(arrow2.current, {
                      css: {
                        marginLeft: '17px',
                      },
                      duration: 0.8,
                      ease: 'power4',
                    });
                    gsap.to(footerHand.current, {
                      y: '+=400px',
                      duration: 0.8,
                      ease: 'power4',
                    });
                  }}
                >
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=michaelwest505@gmail.com&su=JOB PROPOSAL&body=BODY"
                    className={classes.buttonLink}
                    target="__blank"
                  >
                    Drop an Email
                    <svg
                      ref={arrow2}
                      viewBox="0 0 15.41 9.41"
                      width="17px"
                      fill="#ffffff"
                      style={{ marginLeft: '12px' }}
                    >
                      <g>
                        <path d="M10.71 0a2 2 0 000 2.83.52.52 0 01-.37.88H0v2h10.34a.52.52 0 01.37.88 2 2 0 000 2.82l4.7-4.7z" />
                      </g>
                    </svg>
                  </a>
                </Button>
              </Typography>
            </ScrollReveal>
          </Container>
        </section>
        <Footer />
      </main>
      <div className={classes.projectDetails} ref={projectDetails}>
        <div className={classes.projButtonsContainer}>
          <Button
            className={classes.projectCloseButton}
            onClick={hideProjectVisibility}
          >
            CLOSE
          </Button>
          <div className={classes.projNavContainer}>
            <Button
              className={classes.projPrevNextButton}
              onClick={() => prevProject(projectsList)}
            >
              ←
            </Button>
            <Button
              className={classes.projPrevNextButton}
              onClick={() => nextProject(projectsList)}
            >
              →
            </Button>
          </div>
        </div>

        <div className={classes.activeProjectTitle}>
          <Typography
            variant={`${isMobile ? 'h6' : 'h2'}`}
            style={{ color: activeProject.maskColor }}
          >
            {activeProject.id}
          </Typography>
          <Blinker color={activeProject.maskColor} large />
          <Typography
            variant={`${isMobile ? 'h6' : 'h2'}`}
            style={{ color: activeProject.maskColor }}
          >
            {activeProject.title}
          </Typography>
        </div>
        <div className={classes.activeProjectDescription}>
          <Typography variant="caption">{activeProject.description}</Typography>
        </div>
        <div className={classes.mockUpContainer}>
          <img src={activeProject.mockUp} alt={activeProject.title} />
        </div>
      </div>
    </Layout>
  );
};

export default Homepage;
